import { usePdfViewerWithUrl } from 'framework/pdf/context/usePdfViewerWithUrl';
import { useContext } from 'react';
import { RecordContext } from '../records/RecordContext';
import { DocumentationType } from './DocumentationType';
import { DocumentationTypeUrlRecord } from './DocumentationTypeUrlRecord';
import { useCurrentLanguage } from 'localization/useCurrentLanguage';

export const useViewDocumentation = (file: DocumentationType) => {
	const openPdf = usePdfViewerWithUrl();
	const { documentationTypeRecord } = useContext(RecordContext);

	const onView = async () => {
		openPdf(documentationTypeRecord[file], DocumentationTypeUrlRecord[file]);
	};

	return onView;
};

export const useViewSpeechRizivDocumentation = () => {
	const language = useCurrentLanguage();
	const onViewNl = useViewDocumentation('speech-riziv-info');
	const onViewFr = useViewDocumentation('speech-riziv-info-fr');

	return () => (language === 'fr' ? onViewFr() : onViewNl());
};

export const useViewSinRizivDocumentation = () => {
	const language = useCurrentLanguage();
	const onViewNl = useViewDocumentation('sin-riziv-info');
	const onViewFr = useViewDocumentation('sin-riziv-info-fr');

	return () => (language === 'fr' ? onViewFr() : onViewNl());
};
